import { Injectable } from '@angular/core';
import { ParamMap } from '@angular/router';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { isNil, cloneDeep } from 'lodash-es';
import { ToastrService } from 'ngx-toastr';

import { WavelengthShellService } from 'wavelength-ui';
import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';


import { CleanupLoggerService } from './cleanup.logging.service';
import { ProShip_proship_homeComponent } from './ProShip.proship_home.component';

import { Utilities_ShellService } from './Utilities.shell.service';

@Injectable({ providedIn: 'root' })
export class ProShip_ShellService extends WavelengthShellService  {
  constructor(
    dialog : MatDialog,
    toastr: ToastrService,
    private $logger: CleanupLoggerService,
    public Utilities: Utilities_ShellService,
  ) {
    super(dialog, toastr);
  }

  public ProShip: ProShip_ShellService = this;

  public openproship_home(replaceCurrentView?: boolean) {
    this.$logger.log('ProShip', 'proship_home');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'ProShip home page',
        referenceName: 'ProShip_proship_home',
        component: ProShip_proship_homeComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openproship_homeDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('ProShip', 'proship_home');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      ProShip_proship_homeComponent,
      'ProShip home page',
      mode,
      dialogSize
    )
  }

  public override getComponentInformation(referenceName: string, params: ParamMap): { title: string, component: any, inParams: any } {
    if (referenceName === 'ProShip_proship_home') {
      this.$logger.log('ProShip', 'proship_home');
      const title = 'ProShip home page';
      const component = ProShip_proship_homeComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }


    let result = null;
    result = this.Utilities.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    return result;
  }
}
